import { Database, get, ref, set, update } from 'firebase/database';
import { Lesson } from '@opanuj/shared/types';

export const slotDelete = async (database: Database, { id }: { id: string }): Promise<void> => {
	await get(ref(database, `lessons`)).then((snapshot) => {
		const lessonsData = snapshot.val();
		const lessonsToDelete = Object.entries<Lesson>(lessonsData ?? {}).filter(([lessonId, lesson]) => lesson.sourceSlot === id);
		return lessonsToDelete;
	}).then(async (lessonsToDelete) => {
		const deletions: { [path: string]: null } = {};
		lessonsToDelete.forEach(([lessonId, lesson]) => {
			deletions[`lessons/${lessonId}`] = null;
		});
		if (Object.keys(deletions).length > 0) {
			await update(ref(database), deletions);
		}
	});
	return set(ref(database, `slots/${id}`), null);
}